import { Tooltip } from '@mui/material';
import DeviceThermostatIcon from '@mui/icons-material/DeviceThermostat';
import { SensorState, SensorType, sensorTypeStr } from '../../../types/sensor';

interface SensorStateProps {
    sensorType: SensorType;
    sensorId: number;
    sensorState?: SensorState;
}

const ERROR_COLOR = '#f44336';

function getColor(state?: SensorState): string {
    if (state === undefined) return 'inherit';
    // prettier-ignore
    switch (state) {
        case SensorState.SensorStateOk           : return 'inherit';
        case SensorState.SensorStateAnyDataBroken: return ERROR_COLOR;
        case SensorState.SensorStatePowerError   : return ERROR_COLOR;
        case SensorState.SensorStateNotConnected : return ERROR_COLOR;
        case SensorState.SensorStateUndefSensor  : return ERROR_COLOR;
        default                                  : return 'inherit';
    }
}

function getStateLabel(state: SensorState): string {
    // prettier-ignore
    switch (state) {
        case SensorState.SensorStateOk           : return 'ОК';
        case SensorState.SensorStateAnyDataBroken: return 'Ошибка данных';
        case SensorState.SensorStatePowerError   : return 'Ошибка питания';
        case SensorState.SensorStateNotConnected : return 'Не подключён';
        case SensorState.SensorStateUndefSensor  : return 'Неизвестный датчик';
        default                                  : return '';
    }
}

export default function SensorStateIcon({ sensorType, sensorId, sensorState }: SensorStateProps) {
    if (sensorType === SensorType.UnknownSensorType || sensorState === undefined) return null;
    if (sensorState === SensorState.SensorStateOk) return null;

    const label =
        sensorState !== undefined
            ? `${sensorTypeStr(sensorType)}-${sensorId}: ${getStateLabel(sensorState)}`
            : `${sensorTypeStr(sensorType)}-${sensorId}`;

    return (
        <Tooltip title={label} arrow>
            <DeviceThermostatIcon sx={{ fontSize: 18, color: getColor(sensorState), cursor: 'default' }} />
        </Tooltip>
    );
}
